// extracted by mini-css-extract-plugin
export var bubble = "_35-0";
export var container = "_35-f";
export var contrastBorder = "_35-g";
export var greyOut = "_35-2";
export var initialsColor0 = "_35-3";
export var initialsColor1 = "_35-4";
export var initialsColor10 = "_35-d";
export var initialsColor11 = "_35-e";
export var initialsColor2 = "_35-5";
export var initialsColor3 = "_35-6";
export var initialsColor4 = "_35-7";
export var initialsColor5 = "_35-8";
export var initialsColor6 = "_35-9";
export var initialsColor7 = "_35-a";
export var initialsColor8 = "_35-b";
export var initialsColor9 = "_35-c";
export var initialsWrapper = "_35-1";
export var large = "_35-l";
export var medium = "_35-k";
export var mediumSmall = "_35-j";
export var mediumSmallMedium = "_35-o";
export var micro = "_35-h";
export var small = "_35-i";
export var tiny = "_35-n";
export var xTiny = "_35-m";